function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeedback1 = function SvgFeedback1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.847,
    height: 12.654
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#ced3e4",
    d: "M287.728 412.505h-6.347V406.2q0-5.624 6.347-6.345v3.154a2.913 2.913 0 0 0-3.154 3.191h3.154Zm9.5 0h-6.347V406.2q0-5.624 6.347-6.345v3.154a2.913 2.913 0 0 0-3.154 3.191h3.154Z",
    style: {
      isolation: "isolate"
    },
    transform: "translate(-281.381 -399.851)"
  }));
};
export default SvgFeedback1;